import { useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import PeopleIcon from "@mui/icons-material/People";
import Visibility from "@mui/icons-material/Visibility";
import { Box } from "@mui/material";

import { EBenefitTypes } from "../../permissions/benefits/enums/benefits.enums";
import { selectEntitlement } from "../../permissions/benefits/redux/benefits.selectors";
import { useAppSelector } from "../../redux/hooks/redux";
import { widgetSmallHeight } from "../../utils";
import { WorkforceChartNew } from "../bussiness/charts/WorkforceChartNew";
import { WidgetComponentCharts } from "../common/WidgetComponentCharts";
import { WidgetMenuActions } from "../common/WidgetMenuActions/WidgetMenuActions";
import { SASMenuStyles } from "../ui/styles/inputStyles";
import { WorkforceCreateView } from "../workforce/views/WorkforceCreateView";
import { WorkforceList } from "./components/WorkforceList.tsx";
import { WorkforcePeriodSelector } from "./components/WorkforcePeriodSelector";
import { useGetWorkforceTypeHours } from "./hooks/useGetWorkforceTypeHours";

import { useGetWorkforceAnalaytics } from "./hooks/useGetWorkforceAnalytics";

const getWorkforceActions = (remainingSeats) => [
  {
    label: "Add workforce",
    icon: <AddIcon />,
    modalComponent: <WorkforceCreateView />,
    modalKey: "Dashboard-Workforce-Create",
  },
  {
    label: "See Workforce",
    icon: <Visibility />,
    modalComponent: <WorkforceList />,
    modalKey: "Dashboard-Workforces-List",
  },
];

export const WorkforceWidget = ({ companies }) => {
  const numberOfSeats = useAppSelector(selectEntitlement(EBenefitTypes.SEATS));
  const remainingSeats = numberOfSeats?.remaining;

  const [period, setPeriod] = useState("monthly");

  const { data: workforceTypeHours } = useGetWorkforceTypeHours(period);

  const { data: workforceAnalytics } = useGetWorkforceAnalaytics(period);

  console.log(workforceAnalytics);

  return (
    <WidgetComponentCharts
      swapyName="workforce"
      sxProp={{ height: widgetSmallHeight }}
      title={
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          Workforce
          <Box sx={{ "& > div": { mb: 0 } }}>
            <WorkforcePeriodSelector period={period} setPeriod={setPeriod} />
          </Box>
        </Box>
      }
      icon={<PeopleIcon />}
      dataLabel="Workforce"
      sideDataLabel="Connections"
      dataSize="0 0 70%"
      sideDataSize="0 0 30%"
      data={<WorkforceChartNew hoursByRole={workforceTypeHours} />}
      actions={<WidgetMenuActions actionList={getWorkforceActions(remainingSeats)} sx={SASMenuStyles} />}
    />
  );
};